export default __webpack_public_path__ + "static/media/thumbnail.afb5cf05.png";